import React from 'react';

import { NextPageWithLayout } from 'next';
import NextImage from 'next/image';

import { MetaTags } from '../../components/MetaTags/MetaTags';
import { META_ADVERTISE_TITLE } from '../../constants/constants';

import depthLeft from './assets/depthLeft.png';
import depthRight from './assets/depthRight.png';
import { AdvertiseBottomSection } from './components/AdvertiseBottomSection/AdvertiseBottomSection';
import { AdvertiseEngageSection } from './components/AdvertiseEngageSection/AdvertiseEngageSection';
import { AdvertiseformatSection } from './components/AdvertiseformatSection/AdvertiseformatSection';
import { AdvertiseHeaderSection } from './components/AdvertiseHeaderSection/AdvertiseHeaderSection';
import { BenefitsSection } from './components/BenefitsSection/BenefitsSection';
import { EasyLaunchSection } from './components/EasyLaunchSection/EasyLaunch';

const META_DESCRIPTION = `Dive into a world where millions of passionate anglers and outdoor enthusiasts connect, engage, and share experiences.`;

export const Advertise: NextPageWithLayout = () => (
  <div className="grid grid-cols-1 grid-rows-1">
    <MetaTags title={META_ADVERTISE_TITLE} link="/advertise" description={META_DESCRIPTION} />
    <NextImage
      className="w-col-3 col-start-1 row-start-1 hidden md:block"
      src={depthLeft}
      quality={100}
      alt="depth background left"
    />

    <NextImage
      className="w-col-4 col-start-1 row-start-1 hidden justify-self-end md:block"
      src={depthRight}
      quality={100}
      alt="depth background right"
    />

    <AdvertiseHeaderSection />
    <AdvertiseEngageSection />
    <BenefitsSection />
    <AdvertiseformatSection />
    <EasyLaunchSection />
    <AdvertiseBottomSection />
  </div>
);
